import React, { Component } from "react";
import { connect } from "react-redux";
import Reward from "../dashboard/Reward";
import RewardEditor from "../dashboard/RewardEditor";
import {
  clearReward,
  getRewardWithPagination,
} from "../store/actions/rewardActions";
import { authStateInterface } from "../store/reducers/authReducer";

interface Props {
  authStore: authStateInterface;
  history: any;
  pathName: string;
  confirmationModalVisible: boolean;
  handleOpenConfirmationModal: (visible: boolean) => void;
  getRewardWithPagination: (paginationStartAt: string | Date) => void;
  clearReward: () => void;
}

interface State {
  pageIndex: number;
}

class RewardController extends Component<Props> {
  state: State = {
    pageIndex: 1,
  };

  componentDidMount = () => {
    this.props.getRewardWithPagination("");
  };

  componentDidUpdate(prevProps: Props) {
    if (prevProps.pathName !== this.props.pathName) {
      const searchParams = new URLSearchParams(window.location.search);
      const selectedId = searchParams.get("data");
      if (selectedId === "r") {
        this.handleUpdatePageIndex(1);
        this.props.clearReward();
        this.props.getRewardWithPagination("");
      }
    }
  }

  componentWillUnmount() {
    this.props.clearReward();
  }

  handleUpdatePageIndex = (pageIndex: number) => {
    this.setState({
      pageIndex,
    });
  };

  render() {
    if (this.props.authStore.user?.role !== "SUPER") {
      return null;
    }

    if (this.props.pathName === "/dashboard/reward") {
      return (
        <Reward
          history={this.props.history}
          pageIndex={this.state.pageIndex}
          handleUpdatePageIndex={this.handleUpdatePageIndex}
          getRewardWithPagination={this.props.getRewardWithPagination}
        />
      );
    } else if (this.props.pathName === "/dashboard/rewardEditor") {
      return (
        <RewardEditor
          history={this.props.history}
          confirmationModalVisible={this.props.confirmationModalVisible}
          handleOpenConfirmationModal={this.props.handleOpenConfirmationModal}
        />
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state: any) => {
  return {
    authStore: state.authStore,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    clearReward: () => dispatch(clearReward()),
    getRewardWithPagination: (paginationStartAt: string | Date) =>
      dispatch(getRewardWithPagination(paginationStartAt)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RewardController);
